import * as THREE from "three";
import { useEffect, useCallback, useRef, useState } from "react";
import {useSitePropertiesStore} from "../../store/useGeometryPropertiesStore.js"
import { useMapStore } from "../../store/useMapStore.js";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
//import { useBackgroundclickstore } from "../../store/useUifunctionaitystore.js";
import { useCRSStore } from "../../store/useMapStore.js";
import fetchFlurstueckData from "../sites/Sitequeries.js";
import BoundingBoxPlane from "../BoundingBox.jsx"
import { useSiteExportStore } from "../../store/useSiteExport.js";
import MultiPolygonPlane from "../Buildings/BuildingGeometry.jsx";
import { useLayerStore } from "../../store/useLayerStore.js";
import fetchBuildingData from "./Buildingqueries.js";
import { useBuildingPropertiesStore } from "../../store/useGeometryPropertiesStore.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import { CacheGeometry, LoadFromCache,GetCacheKey, ClearCache } from "../../utils/GeometryHelper.js";
export default function BuildingGeometry() 
{
  const { setGeometryType } = useGeometryTypeStore();  //const updateSitePropertiesStore = useSitePropertiesStore((state) => state.updateSiteProperties);
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const [boundingBoxPlan, setBoundingBoxPlan] = useState([]);
  const visibleLayers = useLayerStore((state) => state.visibleLayers);
  const [buildingEntities, setBuildingEntities] = useState([]);  
  const center = useMapStore(state => state.center);
  const setBuildingsExport = useSiteExportStore((state)=> state.setBuildingEntity)
  const [crs, setCrs] = useState("EPSG3857"); 
  const epsgCRS = useCRSStore((state) => state.epsgCRS);
  const zoom = useMapStore(state => state.zoom);
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);
  const metersPerPixel = useMapStore(state => state.metersPerPixel);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const updateBuildingPropertiesStore = useBuildingPropertiesStore((state) => state.updateBuildingProperties);
  const CACHE_KEY = "cacheBuilding";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
  const fetchData = async () => {
    let data = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
    try {
        if(!data)
        {
            data = await fetchBuildingData(
            boundingBoxNE.lng,
            boundingBoxNE.lat,
            boundingBoxSW.lng,
            boundingBoxSW.lat,
            epsgCRS
          );
          
          if (data && data.length > 0 ) {
            setBuildingEntities(data);
            //setBuildingsExport(data);
            // ClearCache(CACHE_KEY);
            // CacheGeometry(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY, CACHE_VERSION, data)
             console.log("Number of Building entities recieved",data.length);
            //console.log("response from api",data)
          }
        }
        else{
            setBuildingEntities(data);
        }
       
      } catch (error) {
        console.error('Failed to fetch data:', error); 
      }
    };
  // Run on mount
  useEffect(() => 
    {
      fetchData();
     }, []);
  const handleEntitySelect = (entity) => 
    {
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      updateBuildingPropertiesStore(
      entity.objectId,
      entity.objectType,
      entity.lod,
      entity.muncipalityName,
      entity.buildingFunction,
      entity.roofShape,
      entity.measuredheight,
      entity.area,
      entity.volume,
      
    )
    };
 

  return (
    <>
      <group >
      {buildingEntities.length > 0 && (
      <MultiPolygonPlane 
        entities={buildingEntities}
        selectedEntityId={selectedEntityId}
        setSelectedEntityId={setSelectedEntityId}
        scalingFactor={scalingFactor}
        inputVisibilty={visibleLayers.gebaude}
        onEntitySelect={handleEntitySelect}
        className={"LOD2BuildingEntity"}
        topographyVisibilty={visibleLayers.topographie}
      />
    )}
    </group>
    </>
  );
}